import React from 'react';
import BreadcrumbsCustom from './BreadcrumbsCustom/BreadcrumbsCustom';
import Css from './CatalogArea.module.css';
import ContentItems from './ContentItems/ContentItems';
import FiltrtagCloud from './FiltrtagCloud/FiltrtagCloud';
import PaginationCatolog from './PaginationCatolog';
import SortItems from './SortItems/SortItems';



const CatalogArea = (props)  => {
 
  return (
    <div className={Css.content}>
      {/* <BreadcrumbsCustom  {...props}/> */}
      <SortItems {...props}/>
      <FiltrtagCloud {...props}/>
      <ContentItems {...props}/>
      <PaginationCatolog checked={props.checked} paramsQuerry={props.paramsQuerry} catalogUrl={props.catalogUrl} params={props.params} getCatalogItems = {props.getCatalogItems} setCurrentPage = {props.setCurrentPage} countItems={props.countItems} pageSize={props.pageSize} currentPage={props.currentPage} getUrlFiltr={props.getUrlFiltr} valueSelected={props.valueSelected}/>
    </div>
  );
}

export default CatalogArea;